import "./App.css";
import RouteCalculator from "./shortestRoute/routeCalculator";

const App = (): JSX.Element => {
    return (
        <div className="App">
            <RouteCalculator />
        </div>
    );
};

export default App;
